/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetSalesInvoiceDto } from './GetSalesInvoiceDto';
import {
    GetSalesInvoiceDtoFromJSON,
    GetSalesInvoiceDtoFromJSONTyped,
    GetSalesInvoiceDtoToJSON,
} from './GetSalesInvoiceDto';

/**
 * 
 * @export
 * @interface GetEmailWithSalesInvoiceDto
 */
export interface GetEmailWithSalesInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof GetEmailWithSalesInvoiceDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailWithSalesInvoiceDto
     */
    sentTo: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailWithSalesInvoiceDto
     */
    sentCc: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailWithSalesInvoiceDto
     */
    sentFrom: string;
    /**
     * 
     * @type {Date}
     * @memberof GetEmailWithSalesInvoiceDto
     */
    sendDate: Date;
    /**
     * 
     * @type {Array<GetSalesInvoiceDto>}
     * @memberof GetEmailWithSalesInvoiceDto
     */
    salesInvoices?: Array<GetSalesInvoiceDto>;
    /**
     * 
     * @type {string}
     * @memberof GetEmailWithSalesInvoiceDto
     */
    emailType: GetEmailWithSalesInvoiceDtoEmailTypeEnum;
}


/**
 * @export
 */
export const GetEmailWithSalesInvoiceDtoEmailTypeEnum = {
    SalesInvoiceToContractor: 'SalesInvoiceToContractor',
    SalesInvoiceDuplicateToContractor: 'SalesInvoiceDuplicateToContractor',
    SurveyToClient: 'SurveyToClient',
    ExcelImport: 'ExcelImport',
    Applications: 'Applications',
    PositionAppForeign: 'PositionAppForeign',
    ApplicationExecutions: 'ApplicationExecutions',
    Orders: 'Orders',
    OrdersRemind: 'OrdersRemind',
    OrderExecutions: 'OrderExecutions',
    OrderExecutionsRemind: 'OrderExecutionsRemind',
    UnblockEstimateByMonth: 'UnblockEstimateByMonth',
    PurchaserCreatedInOrder: 'PurchaserCreatedInOrder',
    PurchaserEditedInOrder: 'PurchaserEditedInOrder',
    TooManyPurchasersInOrder: 'TooManyPurchasersInOrder',
    ProjectDelayed: 'ProjectDelayed',
    ProjectToCancel: 'ProjectToCancel',
    ProjectDateChange: 'ProjectDateChange',
    PurchaseDeficiencies: 'PurchaseDeficiencies',
    SalesInvoicing: 'SalesInvoicing',
    SpecialInvoicing: 'SpecialInvoicing',
    ContractImportError: 'ContractImportError',
    ContractsWaitingToSign: 'ContractsWaitingToSign',
    SignedContracts: 'SignedContracts',
    CyclicJobError: 'CyclicJobError',
    FvzTeamReminder: 'FVZTeamReminder',
    NoPurchaserInOrder: 'NoPurchaserInOrder',
    MirrorProject: 'MirrorProject',
    MirrorProjectError: 'MirrorProjectError'
} as const;
export type GetEmailWithSalesInvoiceDtoEmailTypeEnum = typeof GetEmailWithSalesInvoiceDtoEmailTypeEnum[keyof typeof GetEmailWithSalesInvoiceDtoEmailTypeEnum];


/**
 * Check if a given object implements the GetEmailWithSalesInvoiceDto interface.
 */
export function instanceOfGetEmailWithSalesInvoiceDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "sentTo" in value;
    isInstance = isInstance && "sentCc" in value;
    isInstance = isInstance && "sentFrom" in value;
    isInstance = isInstance && "sendDate" in value;
    isInstance = isInstance && "emailType" in value;

    return isInstance;
}

export function GetEmailWithSalesInvoiceDtoFromJSON(json: any): GetEmailWithSalesInvoiceDto {
    return GetEmailWithSalesInvoiceDtoFromJSONTyped(json, false);
}

export function GetEmailWithSalesInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEmailWithSalesInvoiceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sentTo': json['sentTo'],
        'sentCc': json['sentCc'],
        'sentFrom': json['sentFrom'],
        'sendDate': (new Date(json['sendDate'])),
        'salesInvoices': !exists(json, 'salesInvoices') ? undefined : ((json['salesInvoices'] as Array<any>).map(GetSalesInvoiceDtoFromJSON)),
        'emailType': json['emailType'],
    };
}

export function GetEmailWithSalesInvoiceDtoToJSON(value?: GetEmailWithSalesInvoiceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'sentTo': value.sentTo,
        'sentCc': value.sentCc,
        'sentFrom': value.sentFrom,
        'sendDate': (value.sendDate.toISOString()),
        'salesInvoices': value.salesInvoices === undefined ? undefined : ((value.salesInvoices as Array<any>).map(GetSalesInvoiceDtoToJSON)),
        'emailType': value.emailType,
    };
}

